/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-07 11:54:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-15 14:40:49
 */
/* eslint-disable */
import Vue from 'vue';
import ElementUI from 'element-ui'
import NProgress from 'nprogress'
import 'element-ui/lib/theme-chalk/display.css'
import '@/assets/element-variables.scss'
import '@/assets/common.styl'
import 'nprogress/nprogress.css'
import App from '@/layouts/App.vue'
import router from '@/router/router'
import echarts from 'echarts'
import Clipboard from 'clipboard';
import '@/assets/iconfont.css'
//引入表格插件
import moreTreeTable from "more-tree-table"
Vue.use(moreTreeTable)
// 默认会找store目录下面的index.js文件
import store from '@/store'
import api from '@/api'
import config from '@/config/config'
import * as utils from '@/utils/utils'
import storage from '@/utils/localstorage'
import { common, login } from '@/mixins/index'
import '@/utils/filter.js'
import { debounce } from '@/utils/utils'

let hostname = window.location.hostname
if (Object.keys(config.initDomain).includes(hostname)) {
  config.domain = Object.assign(config.initDomain.default, config.initDomain[hostname])
} else {
  config.domain = config.initDomain.default
}

store.commit('handleDomainInfo', config.domain)

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$utils = utils
Vue.prototype.$config = config
Vue.prototype.$storage = storage

Vue.prototype.$echarts = echarts
Vue.prototype.clipboard = Clipboard;

// Vue.use(ElementUI)
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
// 混入复用
Vue.mixin(common) // 公共方法
Vue.mixin(login) // 登录部分
// 防抖
Vue.directive('debounce', {
  bind(el, binding) {
    const [fn, ...args] = binding.value;
    el.addEventListener('click', debounce(fn, args));
  },
  unbind(el, binding) {
    const [fn, ...args] = binding.value;
    el.removeEventListener('click', debounce(fn, args));
  }
})
// 权限是否展示此功能
Vue.directive("permission",(el,binding,vnode) => {
   let permissionArr = JSON.parse(localStorage.getItem('permission'))?JSON.parse(localStorage.getItem('permission')):[]
  let val = binding.arg?binding.arg:binding.value
  if(val){
      let flag = permissionArr.includes(val)
      if(flag == false){
         el.style.display = 'none'
      }
  }
})

router.beforeEach((to, from, next) => {
  // 如果合同审核不通过或者没上传
  let ico = document.getElementById("ico")
  ico.setAttribute("href", config.ossDomain+'/'+config.ossAppDir+config.domain.icoUrl );
  document.title = config.domain.title

  if (to.path !== '/login') {
    // api.getUserProfile().then(function (userInfo) {
    //   store.commit('handleUserInfo', userInfo)
    //   console.log("userInfo", userInfo)
    // })
  }
  if (to.path !== '/' && to.path !== '/login') {
    const is_contract = store.state.isContract
    if (is_contract <= 0 || is_contract == 2) {
      return next({path:'/'})
    }
  }
  next()

})

router.afterEach((to, from, next) => {
  setTimeout(() => {
    var _mtac = {"performanceMonitor":1};
    (function() {
      var mta = document.createElement("script");
  		mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
  		mta.setAttribute("name", "MTAH5");
  		mta.setAttribute("sid", "500725142");
  		mta.setAttribute("cid", "500725145");
  		var s = document.getElementsByTagName("script")[0];
  		s.parentNode.insertBefore(mta, s);
    })();
  }, 0)
})

// 配置NProgress进度条选项  —— 动画效果
NProgress.configure({ ease: 'ease', speed: 500, showSpinner: false  })
// 全局路由拦截-进入页面前执行
router.beforeEach((to, from, next) => {
  if (to.path === `/login`) {
    return next()
  }
  next()
})

// 全局后置钩子-常用于结束动画等
router.afterEach(transition => {
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
